import { DestroyRef, effect, inject, Injectable, signal, DOCUMENT } from '@angular/core';
import { APIService } from '../APIService/api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EntsperrAnlageService {
  private readonly doc = inject(DOCUMENT);
  private readonly api = inject(APIService);

  public readonly ostammid = signal<number>(undefined);

  private readonly destroyRef = signal<DestroyRef>(undefined);

  private readonly entsperrOnClose = () => this.api.entsperrAnlageSync(this.ostammid());

  private readonly entsperrAndCleanUp = () => {
    firstValueFrom(this.api.entsperrAnlage(this.ostammid()));
    this.ostammid.set(undefined);
    this.destroyRef.set(undefined);
    this.doc.defaultView.removeEventListener('beforeunload', this.entsperrOnClose);
  };

  constructor() {
    effect(() => {
      // * Website/Browser is closed
      if (!this.ostammid()) return;

      this.doc.defaultView.addEventListener('beforeunload', this.entsperrOnClose);
    });

    effect(() => {
      // * Component is destroyed (closed by buttons)
      if (!this.destroyRef() || !this.ostammid()) return;

      this.destroyRef().onDestroy(this.entsperrAndCleanUp);
    });
  }

  public registerDestroyRef(ref: DestroyRef) {
    // * Ignore when destroyRef is set (inspektionsdialog)
    if (this.destroyRef()) return;
    this.destroyRef.set(ref);
  }
}
